import BeSimpleAPI from '@/providers/api/'

import { baseActions } from './../base_actions'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_CORE_API_URL),
    notes: [],
    attachments: []
}

const getters = {
    //List getters
    notes: state => state.notes,
    attachments: state => state.attachments
}

const actions = {
    downloadAttachment({state}, attachment) {
        return baseActions.downloadFile(state, `entities/${attachment.entityId}/attachments/${attachment.id}/file`, `${attachment.name}`)
    },
    uploadAttachment({commit, state}, params) {
        return new Promise((resolve,reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(params.content);
            reader.onload = function () {
                params.content = reader.result;
                state.api.create(`entities/${params.entityId}/attachments`,params)
                .then((response) => {
                    commit('add', {
                        resource: 'attachments',
                        result: response.data.result
                    });
                    resolve(response.data.result);
                })
                .catch((response) => {
                    reject(response);
                })
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    },
    addNote({commit, state}, params) {
        return new Promise((resolve,reject) => {
            state.api.create(`entities/${params.entityId}/notes`,params)
            .then((response) => {
                commit('add', {
                    resource: 'notes',
                    result: response.data.result
                });
                resolve(response.data.result);
            })
            .catch((response) => {
                reject(response);
            })
        });
    },
    getEntities({commit, state}, {resource, entityId}) {
        return new Promise((resolve) => {
            state.api.all(`entities/${entityId}/${resource}`)
            .then((response)=> {
                commit('all', {
                    resource: resource,
                    result: response.data.result
                });
                resolve(response.data.result);
            })
        });
    },
    create({commit, state}, {resource, entityId, params}) {
        return new Promise((resolve) => {
            state.api.create(`entities/${entityId}/${resource}`, params)
            .then((response) => {
                commit('add',
                { 
                    resource: resource,
                    result: response.data.result 
                });
                this.dispatch('errors/clearErrors');
                resolve(response.data.result);
            })
            .catch((error) => {
                this.dispatch('errors/setErrors', error);
            });
        })
    },
    delete({commit, state}, {resource, entityId, id}) {
        return new Promise((resolve,reject) => {
            state.api.delete(`entities/${entityId}/${resource}`, id)
            .then(() => {
                commit('delete', {
                    resource: resource,
                    id: id
                });
                resolve(id);
            })
            .catch((error)=> {
                reject(error);
            });
        });
    },
}

const mutations = {
    all(state, payload) {
        state[payload.resource] = payload.result;
    },
    add(state, payload) {
        state[payload.resource].push(payload.result);
    },
    delete(state, payload) {
        var item = state[payload.resource].filter(({id}) => id == payload.id);
        if(item != undefined) {
            state[payload.resource].splice(state[payload.resource].indexOf(item[0]), 1);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}